export default __webpack_public_path__ + "static/media/learnMore.25171506.svg";